"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORMATS = void 0;
exports.IonAd = IonAd;
exports.IonAdSlot = IonAdSlot;
exports.clearSlots = clearSlots;
exports["default"] = void 0;
exports.enableLazyLoad = enableLazyLoad;
exports.enableSingleRequest = enableSingleRequest;
exports.getSlots = getSlots;
exports.performSingleRequest = performSingleRequest;

var _react = _interopRequireWildcard(require("react"));

var _useHasMounted = _interopRequireDefault(require("./useHasMounted"));

var _ionMedia = require("ion-media");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var slots = {};
var refreshingSlots = [];
var events = [];
var options = {
  enableSingleRequest: false,
  enableLazyLoad: false
};

if (typeof window !== 'undefined') {
  window.googletag = window.googletag || {
    cmd: []
  };
}

function getSlots() {
  return slots;
}

var FORMATS = {
  leaderboard: {
    desktop: [[728, 90], [970, 90], [970, 250]],
    tablet: [[728, 90]],
    mobile: [[320, 50], [300, 50]]
  },
  mpudynamic: {
    desktop: [[300, 250], [300, 600]],
    tablet: [[300, 250]],
    mobile: [[300, 250], [336, 280]]
  },
  mpusection: {
    tablet: [[300, 250]],
    mobile: [[300, 250]]
  },
  mpu: {
    desktop: [[300, 250]],
    tablet: [[300, 250]],
    mobile: [[300, 250], [336, 280]]
  },
  inarticle: {
    desktop: [[300, 250]],
    tablet: [[300, 250]],
    mobile: [[300, 250], [336, 280]]
  }
};
exports.FORMATS = FORMATS;

function clearSlots() {
  if (typeof window !== 'undefined') {
    console.warn('### CLEARING ALL AD SLOTS ###');
    var _window = window,
        _googletag = _window.googletag;

    _googletag.cmd.push(function () {
      events.forEach(function (item) {
        return _googletag.pubads().removeEventListener('slotRenderEnded', item);
      });

      _googletag.destroySlots();
    });

    slots = {};
    refreshingSlots = [];
  }
}

function enableSingleRequest() {
  options.enableSingleRequest = true;
}

function enableLazyLoad() {
  options.enableLazyLoad = true;
}

function performSingleRequest(slotId) {
  googletag.cmd.push(function () {
    googletag.display(slotId);
  });
}

function IonAdSlot(_ref) {
  var slotId = _ref.slotId,
      path = _ref.path,
      targeting = _ref.targeting,
      className = _ref.className,
      sizes = _ref.sizes,
      refreshTime = _ref.refreshTime,
      collapseEmptyDiv = _ref.collapseEmptyDiv,
      onSlotRenderEnded = _ref.onSlotRenderEnded,
      onAdSlotRegistered = _ref.onAdSlotRegistered;
  // Set up the onSlotRenderended event handler
  (0, _react.useEffect)(function () {
    var _window2 = window,
        googletag = _window2.googletag;

    var __onSlotRenderEnded = function __onSlotRenderEnded(event) {
      if (event.slot === slots[slotId]) {
        var _sizes = sizes.map(function (elem) {
          return elem.join('x');
        }).join('|');

        var _targeting = [];

        _targeting.push(Object.getOwnPropertyNames(targeting)[0]);

        _targeting.push(targeting[_targeting[0]]);

        console.log('### Ad Rendered:', 'targeting:', _targeting.join(':'), 'path:', path, 'sizes:', _sizes, 'isEmpty:', event.isEmpty, 'event:', event);

        if (onSlotRenderEnded) {
          onSlotRenderEnded(event);
        }
      }
    };

    googletag.cmd.push(function () {
      events.push(__onSlotRenderEnded);
      googletag.pubads().addEventListener('slotRenderEnded', __onSlotRenderEnded);
    });
  }, []);
  (0, _react.useEffect)(function () {
    var _window3 = window,
        googletag = _window3.googletag;
    googletag.cmd.push(function () {
      googletag.pubads().addEventListener('impressionViewable', function (event) {
        var slot = event.slot;

        if (slot.getTargeting('refresh').indexOf('true') > -1) {
          var targetingKeys = slot.getTargetingKeys();

          if (refreshingSlots.indexOf(slot) < 0) {
            var secondsToWait = slot.getTargeting('refreshTime')[0];
            console.log('### Scheduling slot refresh in', secondsToWait, 'seconds -', targetingKeys[0], ':', slot.getTargeting(targetingKeys[0]));
            refreshingSlots.push(slot);
            setTimeout(function () {
              googletag.pubads().refresh([slot]);
              var idx = refreshingSlots.indexOf(slot);

              if (idx >= 0) {
                refreshingSlots.splice(idx, 1);
              }
            }, secondsToWait * 1000);
          }
        }
      });
    });
  }, []); // Configure and setup the slot

  (0, _react.useEffect)(function () {
    var _window4 = window,
        googletag = _window4.googletag; // Do not redeclare slots

    if (!slots[slotId]) {
      slots[slotId] = 'pending';
      var _targeting = [];

      if (targeting) {
        _targeting.push(Object.getOwnPropertyNames(targeting)[0]);

        _targeting.push(targeting[_targeting[0]]);
      }

      googletag.cmd.push(function () {
        console.log('### Ad configuring slot', {
          targeting: targeting,
          slotId: slotId
        });

        try {
          var slot = googletag.defineSlot(path, sizes, slotId).setCollapseEmptyDiv(!!collapseEmptyDiv).addService(googletag.pubads());

          if (_targeting.length) {
            slot.setTargeting(_targeting[0], _targeting[1]);
          }

          if (refreshTime) {
            slot.setTargeting('refresh', 'true');
            slot.setTargeting('refreshTime', refreshTime);
          }

          slots[slotId] = slot;

          if (onAdSlotRegistered) {
            onAdSlotRegistered(slotId);
          }

          if (options.enableLazyLoad) {
            // googletag.pubads().disableInitialLoad()
            googletag.pubads().enableLazyLoad();
          }

          if (options.enableSingleRequest) {
            googletag.pubads().enableSingleRequest();
          } else {
            googletag.cmd.push(function () {
              googletag.display(slotId);
            });
          }

          googletag.enableServices();
        } catch (e) {
          console.error(e.message);

          var _sizes = sizes.map(function (elem) {
            return elem.join('x');
          }).join('|');

          console.error('slotId:', {
            targeting: _targeting.join(':'),
            path: path,
            sizes: _sizes
          });
        }
      });
    }
  }, [targeting, path, sizes, slotId, collapseEmptyDiv, onSlotRenderEnded]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: slotId,
    className: className
  });
}

function IonAd(_ref2) {
  var slotId = _ref2.slotId,
      path = _ref2.path,
      targeting = _ref2.targeting,
      refreshTime = _ref2.refreshTime,
      className = _ref2.className,
      adNotice = _ref2.adNotice,
      desktop = _ref2.desktop,
      tablet = _ref2.tablet,
      mobile = _ref2.mobile,
      collapseEmptyDiv = _ref2.collapseEmptyDiv,
      onSlotRenderEnded = _ref2.onSlotRenderEnded,
      onAdSlotRegistered = _ref2.onAdSlotRegistered;
  var debug = !process.env.RAZZLE_ENABLE_GAM;
  var _targeting = [];

  _targeting.push(Object.getOwnPropertyNames(targeting)[0]);

  _targeting.push(targeting[_targeting[0]]);

  return /*#__PURE__*/_react["default"].createElement(_useHasMounted["default"], null, !debug && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ionMedia.Desktop, null, desktop && desktop.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: className || 'advert'
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, adNotice && /*#__PURE__*/_react["default"].createElement("small", null, "Advertisement"), /*#__PURE__*/_react["default"].createElement(IonAdSlot, {
    targeting: targeting,
    path: path,
    sizes: desktop,
    refreshTime: refreshTime,
    collapseEmptyDiv: collapseEmptyDiv,
    slotId: slotId,
    className: "",
    onSlotRenderEnded: onSlotRenderEnded,
    onAdSlotRegistered: onAdSlotRegistered
  })))), /*#__PURE__*/_react["default"].createElement(_ionMedia.Tablet, null, tablet && tablet.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: className || 'advert'
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, adNotice && /*#__PURE__*/_react["default"].createElement("small", null, "Advertisement"), /*#__PURE__*/_react["default"].createElement(IonAdSlot, {
    targeting: targeting,
    path: path,
    sizes: tablet,
    refreshTime: refreshTime,
    collapseEmptyDiv: collapseEmptyDiv,
    slotId: slotId,
    className: "",
    onSlotRenderEnded: onSlotRenderEnded,
    onAdSlotRegistered: onAdSlotRegistered
  })))), /*#__PURE__*/_react["default"].createElement(_ionMedia.Mobile, null, mobile && mobile.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: className || 'advert'
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, adNotice && /*#__PURE__*/_react["default"].createElement("small", null, "Advertisement"), /*#__PURE__*/_react["default"].createElement(IonAdSlot, {
    targeting: targeting,
    path: path,
    sizes: mobile,
    refreshTime: refreshTime,
    collapseEmptyDiv: collapseEmptyDiv,
    slotId: slotId,
    className: "",
    onSlotRenderEnded: onSlotRenderEnded,
    onAdSlotRegistered: onAdSlotRegistered
  }))))), debug && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ionMedia.Desktop, null, desktop && desktop.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, adNotice && /*#__PURE__*/_react["default"].createElement("small", null, "Advertisement"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    src: '//via.placeholder.com/' + desktop.reduce(function (p, c) {
      if (p[0] * p[1] > c[0] * c[1]) {
        return p;
      } else {
        return c;
      }
    }).join('x') + '?text=' + _targeting.join(':'),
    alt: ""
  }))))), /*#__PURE__*/_react["default"].createElement(_ionMedia.Tablet, null, tablet && tablet.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, adNotice && /*#__PURE__*/_react["default"].createElement("small", null, "Advertisement"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    className: "advert",
    src: '//via.placeholder.com/' + tablet.reduce(function (p, c) {
      if (p[0] * p[1] > c[0] * c[1]) {
        return p;
      } else {
        return c;
      }
    }).join('x') + '?text=' + _targeting.join(':'),
    alt: ""
  }))))), /*#__PURE__*/_react["default"].createElement(_ionMedia.Mobile, null, mobile && mobile.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, adNotice && /*#__PURE__*/_react["default"].createElement("small", null, "Advertisement"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    className: "advert",
    src: '//via.placeholder.com/' + mobile.reduce(function (p, c) {
      if (p[0] * p[1] > c[0] * c[1]) {
        return p;
      } else {
        return c;
      }
    }).join('x') + '?text=' + _targeting.join(':'),
    alt: ""
  })))))));
}

var _default = IonAd;
exports["default"] = _default;